import React from 'react';
import { Tabs, Tab, Paper } from '@mui/material';

export default ({ tabs = [], selectedTab, onChange = null }) => {
  const [value, setValue] = React.useState(selectedTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div>
      <Paper square>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs"
          indicatorColor="primary"
          textColor="primary"
        >
          {tabs.map(({ tabName }) => (
            <Tab label={tabName} key={tabName} aria-controls={`tab-label-${tabName}`} />
          ))}
        </Tabs>
      </Paper>

      {tabs.map(({ tabName, render }, index) => (
        <div key={tabName} aria-labelledby={`tab-label-${tabName}`} hidden={value !== index}>
          {render}
        </div>
      ))}
    </div>
  );
};
